import { Core } from '../../Constants';
import { owl } from '../../Vocabs';
import Nothing from '../Nothing';
export function Mixin(Base) {
    class SupportedOperation extends Base {
        get method() {
            return this.getString(Core.Vocab('method')) || '';
        }
        get expects() {
            return this.get(Core.Vocab('expects')) || new Nothing(this.apiDocumentation);
        }
        get returns() {
            return this.get(Core.Vocab('returns')) || new Nothing(this.apiDocumentation);
        }
        get requiresInput() {
            const method = this.method || '';
            const methodExpectsBody = method.toUpperCase() !== 'GET' && this.method.toUpperCase() !== 'DELETE';
            const operationExpectsBody = !!this.expects && this.expects.id !== owl.Nothing;
            return methodExpectsBody || operationExpectsBody;
        }
    }
    return SupportedOperation;
}
export const shouldApply = (res) => res.types.contains(Core.Vocab('Operation'));
//# sourceMappingURL=SupportedOperation.js.map